import { render, staticRenderFns } from "./input-textarea.vue?vue&type=template&id=2898ba52&"
import script from "./input-textarea.vue?vue&type=script&lang=js&"
export * from "./input-textarea.vue?vue&type=script&lang=js&"
import style0 from "./input-textarea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "input-textarea.vue"
export default component.exports